module.exports = __webpack_public_path__ + "static/img/loginhead.cf59e74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginhead.png
// module id = A+Ov
// module chunks = 1